<template>
  <div class="flex items-center gap-2 bg-base-200 p-2" @click="clickMateLink">
    <MateAvatarNameBioCard
      :mate="item.targetMate!"
      avatar-class="w-12"
      bio-class="line-clamp-2"
      class="flex-1"
      show-mock-name
    />
    <div class="flex items-center gap-1 flex-col">
      <VanSwitch
        :model-value="item.isActive"
        size="14"
        :loading="switchLoading"
        @click.stop="clickSwitch(item)"
      />
      <span class="text-xs text-base-content/70">
        {{ item.isActive ? $t("treehole.actived") : $t("treehole.unactived") }}
      </span>
    </div>
  </div>
</template>

<script setup lang="ts">
import { MateLink } from "@/types/entity";
import { ref } from "vue";
import { useRouter } from "vue-router";
import { useMate } from "@/stores/mate";

const props = defineProps<{
  item: MateLink;
}>();
const router = useRouter();
const mateStore = useMate();

const switchLoading = ref(false);

const clickMateLink = () => {
  router.push({
    name: "mateHome",
    params: {
      uuid: props.item.targetMate?.uuid,
    },
    query: {
      isTreehole: 1,
      mateLinkId: props.item.id,
    },
  });
};

const clickSwitch = async (item: MateLink) => {
  if (switchLoading.value) return;
  switchLoading.value = true;
  await mateStore.updateMateLink(item.id!, !item.isActive);
  switchLoading.value = false;
};
</script>
